/* eslint-disable class-methods-use-this */
import { ContactTypeId } from '@constants/enums';
import { regexReplaceEmptySpaces } from '../AddContactForm/constants';
import {
  CreateContactPayload,
  FrontendStructure,
  IBeneficiaryRelationshipId,
} from '../AddContactForm/types';

export default class BuildNewContactService {
  cleanObject = (obj: any): any => {
    const cleanedObject: { [key: string]: any } = {};
    Object.keys(obj).forEach((key) => {
      if (obj[key] && typeof obj[key] === 'object') {
        cleanedObject[key] = this.cleanObject(obj[key]);
      } else if (
        obj[key] !== null &&
        obj[key] !== undefined &&
        obj[key] !== ''
      ) {
        cleanedObject[key] = obj[key];
      }
    });
    return cleanedObject;
  };

  build = (data: FrontendStructure): CreateContactPayload => {
    const {
      accountCurrency,
      accountNumber,
      accountType,
      address,
      address2,
      bankName,
      city,
      clabe,
      companyName,
      contact1,
      contactPhone,
      country,
      countryId,
      documentType,
      email,
      entity,
      entityBusiness,
      firstName,
      id,
      identificationNumber,
      lastName,
      name,
      postCode,
      providerRelation,
      rfc,
      routingNumber,
      sftEntAddr,
      sftEntBnk,
      state,
      swiftCode,
      transferMethod,
      bankCountryCode,
    } = data;
    let newFirstName;
    let newLastName;
    if (!firstName && !lastName && name) {
      [newFirstName, newLastName] = name.split(' ');
    }

    const newCompanyName =
      companyName ||
      (firstName ?? newFirstName).replace(regexReplaceEmptySpaces, ' ');

    const benefiaryValue =
      IBeneficiaryRelationshipId[
        providerRelation as keyof typeof IBeneficiaryRelationshipId
      ];
    const isValidBeneficiary =
      benefiaryValue !== 0 ? benefiaryValue : undefined;
    const fixedPayload: CreateContactPayload = {
      id,
      email,
      beneficiaryRelationshipId: providerRelation
        ? isValidBeneficiary
        : undefined,
      contactTypeId: countryId
        ? ContactTypeId.SWIFT_CONTACT
        : ContactTypeId.REGULAR_CONTACT,
      contactNaturalPersonEnterprise: {
        naturalPerson: {
          country,
          countryId,
          documentType,
          documentNumber: identificationNumber,
          email,
          firstName: (firstName ?? newFirstName)
            .replace(regexReplaceEmptySpaces, ' ')
            .trim(),
          lastName: (lastName ?? newLastName)
            .replace(regexReplaceEmptySpaces, ' ')
            .trim(),
          phoneNumber: contactPhone || contact1 || '',
        },
        enterprise: {
          country,
          countryId,
          entity_type: (entityBusiness ?? entity).toUpperCase(),
          name: newCompanyName,
          rfc: rfc || '',
        },
      },
      enterpriseBankAccount: {
        id: sftEntBnk || undefined,
        accountCurrency: accountCurrency || '',
        bankCountryCode: bankCountryCode || undefined,
        accountNumber,
        accountType,
        bankName,
        countryId,
        clabe,
        swiftCode,
        transferMethod,
        routingNumber,
      },
      enterpriseAddress: {
        id: sftEntAddr || undefined,
        city,
        state,
        addressLine1: address,
        addressLine2: address2,
        postCode,
        name: newCompanyName,
      },
    };

    return this.cleanObject(fixedPayload);
  };
}
